import React, { useRef } from "react";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import { useState, useEffect } from "react";
import axios from "axios";
import "./Bureau.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { url } from "../../../../../../../../../App";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from "js-cookie";
import styles from "../../../Analysis/Components/VerificationNew/VerificationNew.module.css";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

const Bureau = () => {
  const { loanid } = useParams();
  const loanId = loanid;
  const [open, setOpen] = React.useState(false);
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const { borrowerData } = useBorrowerContext();
  const fetchedLoanDetails = borrowerData.loan;
  const [cibilScore, setcibilScore] = useState("");
  const [loanStartDate, setloanStartDate] = useState("");
  const [dpdLoan, setdpdLoan] = useState("");
  const [dpdGreaterthen30, setdpdGreaterthen30] = useState("");
  const [dpdGreaterthen90, setdpdGreaterthen90] = useState("");
  const [cheque6Months, setcheque6Months] = useState("");
  const [cheque12Months, setcheque12Months] = useState("");
  const [tradelines, settradelines] = useState("");
  const [activeTab, setActiveTab] = useState("");
  const coapplicantDetails = borrowerData.coapplicant;
  const matchingcoapplicants = coapplicantDetails.filter(
    (coapplicant) => coapplicant.coapplicant_loan_id === loanId
  );
  const numberOfCoapplicants = matchingcoapplicants.length;
  const matchingloans = fetchedLoanDetails.filter(
    (loan) => loan.loan_id === loanId
  );
  const loanStatus = matchingloans[0]?.loan_status;
  const [loanDisbursed, setIsloanDisbursed] = useState(false);
  const [bureauVendor, setBureauVendor] = useState("Equifax");
  const [customerName, setCustomerName] = useState("");
  const [reqArray, setReqArray] = useState([]);
  const [borrowerBureau, setBorrowerBureau] = useState([]);
  const [coapplicantBureau1, setCoapplicantBureau1] = useState([]);
  const [coapplicantBureau2, setCoapplicantBureau2] = useState([]);
  const [coapplicantBureau3, setCoapplicantBureau3] = useState([]);
  const [visible, setvisible] = useState(false);
  const [addBureau, setAddBureau] = useState(false);
  const [deleteBureau, setDeleteBureau] = useState(false);
  const [cibilFile, setCibilFile] = useState(null);
  const [selectedCoapplicantId, setSelectedCoapplicantId] = useState(null);

  console.log(selectedCoapplicantId);

  // var fullName = [
  //     borrowerData?.borrower?.borrower_firstname,
  //     borrowerData?.borrower?.borrower_middlename,
  //     borrowerData?.borrower?.borrower_lastname,
  // ]
  //     .filter(Boolean)
  //     .join(" ");

  // console.log(fullName);

  // var coapplicantNames = borrowerData.coapplicant.map(item => item.coapplicant_name);

  // console.log(coapplicantNames);

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email,
        })
        .then((res) => {
          setAddBureau(res.data[0]?.permission.add_bureau_cam);
          setDeleteBureau(res.data[0]?.permission.delete_bureau_cam);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [email, token]);

  useEffect(() => {
    if (loanStatus === "DISBURSED") {
      setIsloanDisbursed(false);
    } else {
      setIsloanDisbursed(true);
    }
  }, [loanStatus]);

  // const handleData = (bureauData) => {
  //   console.log(bureauData);
  //   setActiveTab(bureauData);
  //   setOpen(true);

  //   // if (bureauData === "App") {
  //   //     setborrowerName(fullName)
  //   // }

  //   // if (bureauData === "Coapp1") {
  //   //     setborrowerName(coapplicantNames[0])
  //   // }

  //   // if (bureauData === "Coapp2") {
  //   //     setborrowerName(coapplicantNames[1])
  //   // }

  //   // if (bureauData === "Coapp3") {
  //   //     setborrowerName(coapplicantNames[2])
  //   // }

  //   axios
  //     .post(url + "/cam/get/cam/data", {
  //       token: token,
  //       email: email,
  //       loanId: loanId,
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       console.log(bureauData);
  //       // console.log(activeTab);
  //       setReqArray("");
  //       setOpen(false);

  //       if (res?.data?.borrower_bureau && bureauData === "App") {
  //         setBorrowerBureau(res.data?.borrower_bureau);
  //         setReqArray(res.data?.borrower_bureau);
  //       }

  //       if (res?.data?.coborrower_bureau_1 && bureauData === "Coapp1") {
  //         setCoapplicantBureau1(res.data?.coborrower_bureau_1);
  //         setReqArray(res.data?.coborrower_bureau_1);
  //       }

  //       if (res?.data?.coborrower_bureau_2 && bureauData === "Coapp2") {
  //         setCoapplicantBureau2(res.data?.coborrower_bureau_2);
  //         setReqArray(res.data?.coborrower_bureau_2);
  //       }

  //       if (res?.data?.coborrower_bureau_3 && bureauData === "Coapp3") {
  //         setCoapplicantBureau3(res.data?.coborrower_bureau_3);
  //         setReqArray(res.data?.coborrower_bureau_3);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setOpen(false);
  //     });
  // };

  const handleUpload = async (docName, file) => {
    try {
      setOpen(true);

      if (!file) {
        setOpen(false);
        return;
      }

      let doc_type = file?.name.split(".").pop()?.toLowerCase();
      const allowed = ["jpg", "jpeg", "png", "pdf", "xlsx"];

      if (!allowed.includes(doc_type)) {
        setOpen(false);
        toast.error("Only JPG, PNG, JPEG, PDF or Excel files allowed");
        return;
      }

      if (doc_type === "jpg") doc_type = "jpeg";
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = async (ev) => {
          const base64Data = ev.target.result.split(",").pop();

          let res;

          if (docName === "loan_cibil_report") {
            const payload = {
              borrower_uniqueno: borrowerData?.borrower?.borrower_uniqueno,
              loan_id: loanId,
              doc_name: docName,
              doc_type: doc_type,
              fileName: base64Data,
              token,
              email,
            };

            res = await axios.post(url + "/loan/adddoc", payload);
          } else {
            const payload = {
              token: token,
              email: email,
              coapplicant_id: selectedCoapplicantId,
              doc_name: docName,
              doc_type: doc_type,
              coapplicant_borrower_uniqueno:
                borrowerData?.borrower?.borrower_uniqueno,
              fileName: base64Data,
            };

            res = await axios.post(url + "/coapplicant/adddocument", payload);
          }
          if (!res.data.auth) {
            toast.error(res.data.message);
            setOpen(false);
            return resolve(null);
          }

          console.log(res.data.path)
          toast.success(res.data.message);
          setOpen(false);
          resolve(res.data.path)
        };
        reader.onerror = reject;
      });
    } catch (err) {
      console.error(err);
      setOpen(false);
      toast.error("Upload failed");
    }
  };

  const cibilRef = useRef(null);

  const handleAddData = async (e) => {
    e.preventDefault();
    setOpen(true);

    let newData = {
      bid: Date.now(),
      bureauVendor,
      customerName,
      cibilScore,
      loanStartDate,
      dpdLoan,
      dpdGreaterthen30,
      dpdGreaterthen90,
      cheque6Months,
      cheque12Months,
      tradelines
    };

    let updatedBorrowerBureau = [...borrowerBureau];
    let updatedCoapplicantBureau1 = [...coapplicantBureau1];
    let updatedCoapplicantBureau2 = [...coapplicantBureau2];
    let updatedCoapplicantBureau3 = [...coapplicantBureau3];

    if (activeTab === "App") {
      updatedBorrowerBureau.push(newData);
    }

    const dataWithId = {
      ...newData,
      coapplicant_id: selectedCoapplicantId,
    };
    if (activeTab === "Coapp1") {
      updatedCoapplicantBureau1.push(dataWithId);
    }
    if (activeTab === "Coapp2") {
      updatedCoapplicantBureau2.push(dataWithId);
    }
    if (activeTab === "Coapp3") {
      updatedCoapplicantBureau3.push(dataWithId);
    }

    const payload = {
      token,
      email,
      loanId,
    };

    if (updatedBorrowerBureau.length > 0) {
      payload.borrower_bureau = updatedBorrowerBureau;
    }
    if (updatedCoapplicantBureau1.length > 0) {
      payload.coborrower_bureau_1 = updatedCoapplicantBureau1;
    }
    if (updatedCoapplicantBureau2.length > 0) {
      payload.coborrower_bureau_2 = updatedCoapplicantBureau2;
    }
    if (updatedCoapplicantBureau3.length > 0) {
      payload.coborrower_bureau_3 = updatedCoapplicantBureau3;
    }

    try {
      if (cibilFile) {
        const uploadKey =
          activeTab === "App"
            ? "loan_cibil_report"
            : "coapplicant_cibil_report";

        const path = await handleUpload(uploadKey, cibilFile);
        console.log(path)

        const addPathToLast = (array, filePath) => {
          if (!array || array.length === 0) return array;

          return array.map((item, index) =>
            index === array.length - 1
              ? { ...item, path: filePath }
              : item
          );
        };

        if (activeTab === "App") {
          payload.borrower_bureau = addPathToLast(updatedBorrowerBureau, path);
        }

        if (activeTab === "Coapp1") {
          payload.coborrower_bureau_1 = addPathToLast(updatedCoapplicantBureau1, path);
        }

        if (activeTab === "Coapp2") {
          payload.coborrower_bureau_2 = addPathToLast(updatedCoapplicantBureau2, path);
        }

        if (activeTab === "Coapp3") {
          payload.coborrower_bureau_3 = addPathToLast(updatedCoapplicantBureau3, path);
        }

      }

      const response = await axios.post(`${url}/cam/add/bureau/data`, payload);

      if (activeTab === "App") {
        setBorrowerBureau(updatedBorrowerBureau);
        setReqArray(updatedBorrowerBureau);
      }
      if (activeTab === "Coapp1") {
        setCoapplicantBureau1(updatedCoapplicantBureau1);
        setReqArray(updatedCoapplicantBureau1);
      }
      if (activeTab === "Coapp2") {
        setCoapplicantBureau2(updatedCoapplicantBureau2);
        setReqArray(updatedCoapplicantBureau2);
      }
      if (activeTab === "Coapp3") {
        setCoapplicantBureau3(updatedCoapplicantBureau3);
        setReqArray(updatedCoapplicantBureau3);
      }
      setBureauVendor("");
      setCustomerName("");
      setcibilScore("");
      setloanStartDate("");
      setdpdLoan("");
      setdpdGreaterthen30("");
      setdpdGreaterthen90("");
      setcheque6Months("");
      setcheque12Months("");
      settradelines("");
      setOpen(false);
      setCibilFile(null);
      toast.success(response.data.message);
    } catch (err) {
      setOpen(false);
      toast.error(err.response?.data?.message);
      console.error(err);
    }
  };

  const handleDeleteRow = (bureauId, path) => {
    console.log(path)
    setOpen(true);
    const confirmBureau = window.confirm("Do you want to Delete the Bureau?");
    if (confirmBureau) {
      axios
        .post(url + "/cam/delete/bureau/data", {
          token: token,
          email: email,
          loanId: loanId,
          bid: bureauId,
          borrower_bureau: borrowerBureau,
          coborrower_bureau_1: coapplicantBureau1,
          coborrower_bureau_2: coapplicantBureau2,
          coborrower_bureau_3: coapplicantBureau3,
        })
        .then(async (res) => {
          fetchUpdatedData();
          console.log(path)
          // if (path) {
          await handleDeleteDoc(path);
          // }
          toast.success(res.data.message);
        })
        .catch((err) => {
          console.log(err);
          setOpen(false);
          toast.error(err.response?.data?.message);
        });
    } else {
      setOpen(false);
      toast.error("Bureau not Deleted.");
    }
  };

  const handleDeleteDoc = async (path) => {
    try {
      fetchUpdatedData();
      setOpen(true);
      const uploadKey =
        activeTab === "App"
          ? "loan_cibil_report"
          : "coapplicant_cibil_report";
      let res;
      console.log(path)
      const type = path.split(".").pop();
      console.log(type)
      const rawName = path.split('/').pop();
      const withoutExt = rawName.replace(/\.[^/.]+$/, '');
      const decoded = decodeURIComponent(withoutExt);
      const fileName = decoded.match(/(loan|coapplicant)_.*$/)?.[0];
      console.log(fileName)

      if (uploadKey === "loan_cibil_report") {
        const deleteReq = {
          token: token,
          email: email,
          loan_id: loanId,
          borrower_uniqueno: borrowerData?.borrower?.borrower_uniqueno,
          doc_arr: {
            location: path,
            doc_type: type,
            doc_name: fileName,
          },
        };

        res = await axios.post(url + "/loan/deletedoc", deleteReq);

      } else {
        const request = {
          token: token,
          email: email,
          coapplicant_borrower_uniqueno: borrowerData?.borrower?.borrower_uniqueno,
          coapplicant_id: selectedCoapplicantId,
          doc_arr: {
            location: path,
            doc_type: type,
            doc_name: fileName,
          },
        };

        res = await axios.post(url + "/coapplicant/deletedoc", request);
      }

      if (!res.data.auth) {
        toast.error(res.data.message);
        setOpen(false);
        return false;
      }

      toast.success(res.data.message);
      setOpen(false);

      return true; // ✅ important

    } catch (err) {
      console.error(err);
      setOpen(false);
      toast.error("Delete failed");
      return false;
    }
  };

  const fetchUpdatedData = () => {
    console.log(activeTab);
    axios
      .post(url + "/cam/get/cam/data", {
        token: token,
        email: email,
        loanId: loanId,
      })
      .then((res) => {
        console.log(res.data);
        setOpen(false);
        setReqArray("");

        if (res?.data?.borrower_bureau && activeTab === "App") {
          setBorrowerBureau(res.data?.borrower_bureau);
          setReqArray(res.data?.borrower_bureau);
        }

        if (res?.data?.coborrower_bureau_1 && activeTab === "Coapp1") {
          setCoapplicantBureau1(res.data?.coborrower_bureau_1);
          setReqArray(res.data?.coborrower_bureau_1);
        }

        if (res?.data?.coborrower_bureau_2 && activeTab === "Coapp2") {
          setCoapplicantBureau2(res.data?.coborrower_bureau_2);
          setReqArray(res.data?.coborrower_bureau_2);
        }

        if (res?.data?.coborrower_bureau_3 && activeTab === "Coapp3") {
          setCoapplicantBureau3(res.data?.coborrower_bureau_3);
          setReqArray(res.data?.coborrower_bureau_3);
        }
      })
      .catch((err) => {
        console.log(err);
        setOpen(false);
      });
  };

  const handleData = (bureauData) => {
    console.log(bureauData);
    setActiveTab(bureauData);
    setOpen(true);

    // ---------- SET NAME + ID ----------
    if (bureauData === "App") {
      const loan = matchingloans[0];
      setCustomerName(loan?.borrower_name || "");
      setSelectedCoapplicantId(null);
    }

    if (bureauData === "Coapp1" && matchingcoapplicants[0]) {
      setCustomerName(matchingcoapplicants[0].coapplicant_name);
      setSelectedCoapplicantId(matchingcoapplicants[0].coapplicant_id);
    }

    if (bureauData === "Coapp2" && matchingcoapplicants[1]) {
      setCustomerName(matchingcoapplicants[1].coapplicant_name);
      setSelectedCoapplicantId(matchingcoapplicants[1].coapplicant_id);
    }

    if (bureauData === "Coapp3" && matchingcoapplicants[2]) {
      setCustomerName(matchingcoapplicants[2].coapplicant_name);
      setSelectedCoapplicantId(matchingcoapplicants[2].coapplicant_id);
    }

    axios
      .post(url + "/cam/get/cam/data", {
        token: token,
        email: email,
        loanId: loanId,
      })
      .then((res) => {
        console.log(res.data);

        setReqArray("");
        setOpen(false);

        if (res?.data?.borrower_bureau && bureauData === "App") {
          setBorrowerBureau(res.data.borrower_bureau);
          setReqArray(res.data.borrower_bureau);
        }

        if (res?.data?.coborrower_bureau_1 && bureauData === "Coapp1") {
          setCoapplicantBureau1(res.data.coborrower_bureau_1);
          setReqArray(res.data.coborrower_bureau_1);
        }

        if (res?.data?.coborrower_bureau_2 && bureauData === "Coapp2") {
          setCoapplicantBureau2(res.data.coborrower_bureau_2);
          setReqArray(res.data.coborrower_bureau_2);
        }

        if (res?.data?.coborrower_bureau_3 && bureauData === "Coapp3") {
          setCoapplicantBureau3(res.data.coborrower_bureau_3);
          setReqArray(res.data.coborrower_bureau_3);
        }
      })
      .catch((err) => {
        console.log(err);
        setOpen(false);
      });
  };

  return (
    <div className="obligation-form">
      <form>
        {loanId && (
          <div>
            <button
              type="button"
              className={styles.addhoverButton}
              onClick={() => handleData("App")}
              style={{
                backgroundColor: activeTab === "App" ? "#034ea1" : "#eef7ff",
                color: activeTab === "App" ? "white" : "gray",
              }}
            >
              Applicant
            </button>

            {numberOfCoapplicants > 0 && (
              <button
                type="button"
                className={styles.addhoverButton}
                onClick={() => handleData("Coapp1")}
                style={{
                  backgroundColor:
                    activeTab === "Coapp1" ? "#034ea1" : "#eef7ff",
                  color: activeTab === "Coapp1" ? "white" : "gray",
                }}
              >
                Co-Applicant 1
              </button>
            )}

            {numberOfCoapplicants > 1 && (
              <button
                type="button"
                className={styles.addhoverButton}
                onClick={() => handleData("Coapp2")}
                style={{
                  backgroundColor:
                    activeTab === "Coapp2" ? "#034ea1" : "#eef7ff",
                  color: activeTab === "Coapp2" ? "white" : "gray",
                }}
              >
                Co-Applicant 2
              </button>
            )}

            {numberOfCoapplicants > 2 && (
              <button
                type="button"
                className={styles.addhoverButton}
                onClick={() => handleData("Coapp3")}
                style={{
                  backgroundColor:
                    activeTab === "Coapp3" ? "#034ea1" : "#eef7ff",
                  color: activeTab === "Coapp3" ? "white" : "gray",
                }}
              >
                Co-Applicant 3
              </button>
            )}
          </div>
        )}

        {(activeTab === "App" ||
          activeTab === "Coapp1" ||
          activeTab === "Coapp2" ||
          activeTab === "Coapp3") && (
            <>
              <div className="wrapper-loan-product">
                <div className="nbfc-fields">
                  <label className="product-text">Bureau Vendor</label>
                  <br></br>
                  <select
                    className="inp-loan-product"
                    onChange={(e) => {
                      setBureauVendor(e.target.value);
                    }}
                    value={bureauVendor}
                    required
                    disabled={!loanDisbursed}
                  >
                    <option value="">Select </option>
                    <option value="Cibil">Cibil</option>
                    <option value="Equifax">Equifax</option>
                    <option value="Crif">Crif</option>
                  </select>
                </div>

                <div className="nbfc-fields">
                  <label className="product-text">
                    {activeTab === "App" ? "Borrower Name*" : "Coapplicant Name*"}
                  </label>
                  <br />
                  <input
                    type="text"
                    onChange={(e) => setCustomerName(e.target.value)}
                    disabled
                    value={customerName}
                    required
                    className="inp-loan-product"
                  ></input>
                </div>

                <div className="nbfc-fields">
                  <label className="product-text">Bureau Score</label>
                  <br />
                  <input
                    type="number"
                    onChange={(e) => {
                      setcibilScore(e.target.value);
                    }}
                    disabled={!loanDisbursed}
                    value={cibilScore}
                    className="inp-loan-product"
                  ></input>
                </div>

                <div className="nbfc-fields">
                  <label className="product-text">
                    Credit History in Months (Loan start date)
                  </label>
                  <br />
                  <input
                    type="date"
                    onChange={(e) => {
                      setloanStartDate(e.target.value);
                    }}
                    disabled={!loanDisbursed}
                    value={loanStartDate}
                    className="inp-loan-product"
                    inputProps={{
                        max: new Date().toISOString().split("T")[0],
                    }}
                  ></input>
                </div>
                <div className="nbfc-fields">
                  <label className="product-text">
                    Count of DPD Loan in 3 months
                  </label>
                  <br></br>
                  <input
                    type="number"
                    onChange={(e) => {
                      setdpdLoan(e.target.value);
                    }}
                    disabled={!loanDisbursed}
                    value={dpdLoan}
                    className="inp-loan-product"
                  ></input>
                </div>

                <div className="nbfc-fields">
                  <label className="product-text">
                    Count of Loan with DPD &gt; 30 in last 12 Months
                  </label>
                  <br />
                  <input
                    type="number"
                    onChange={(e) => {
                      setdpdGreaterthen30(e.target.value);
                    }}
                    disabled={!loanDisbursed}
                    value={dpdGreaterthen30}
                    className="inp-loan-product"
                  ></input>
                </div>
                <div className="nbfc-fields">
                  <label className="product-text">
                    Count of loan with DPD &gt; 90
                  </label>
                  <br />
                  <input
                    type="number"
                    required
                    onChange={(e) => {
                      setdpdGreaterthen90(e.target.value);
                    }}
                    disabled={!loanDisbursed}
                    value={dpdGreaterthen90}
                    className="inp-loan-product"
                  ></input>
                </div>
                <div className="nbfc-fields">
                  <label className="product-text">
                    Cheque/ECS bounce in 6 Months
                  </label>
                  <br />
                  <input
                    type="number"
                    required
                    onChange={(e) => {
                      setcheque6Months(e.target.value);
                    }}
                    disabled={!loanDisbursed}
                    value={cheque6Months}
                    className="inp-loan-product"
                  ></input>
                </div>
                <div className="nbfc-fields">
                  <label className="product-text">
                    Cheque/ECS bounce in 12 Months
                  </label>
                  <br />
                  <input
                    type="number"
                    onChange={(e) => {
                      setcheque12Months(e.target.value);
                    }}
                    disabled={!loanDisbursed}
                    value={cheque12Months}
                    className="inp-loan-product"
                  ></input>
                </div>
                <div className="nbfc-fields">
                  <label className="product-text">
                    No. of tradelines with any of the below status:
                    <p className="product-text">
                      1. Suit filed wilful default (except ‘No suit filed’)
                    </p>
                    <p className="product-text">
                      2. Written Off and Settled Status
                    </p>
                  </label>

                  <input
                    type="text"
                    onChange={(e) => {
                      settradelines(e.target.value);
                    }}
                    disabled={!loanDisbursed}
                    value={tradelines}
                    className="inp-loan-product"
                  ></input>
                </div>

                <div className="nbfc-fields">
                  <label className="product-text">Cibil Report</label>

                  <input
                    onChange={(e) => setCibilFile(e.target.files[0])}
                    type="file"
                    ref={cibilRef}
                    disabled={!loanDisbursed}
                    style={{ display: "none" }}
                  />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <button
                      type="button"
                      style={{
                        transition: "background-color 0.3s ease",
                        fontSize: "1rem",
                        borderRadius: "3px",
                        border: "none",
                        backgroundColor: "#034c9b",
                        color: "white",
                        padding: "0.4rem 1rem",
                        marginTop: "1rem",
                        marginLeft: "2rem",
                        marginBottom: "1rem",
                        marginRight: "1rem",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        cibilRef.current.value = null;
                        cibilRef.current.click();
                      }}
                      disabled={!loanDisbursed}
                    >
                      Upload
                    </button>

                    {cibilFile && (
                      <TaskAltIcon style={{ color: "green", marginTop: "6px" }} />
                    )}
                  </div>
                </div>
              </div>
              {(addBureau || visible) && (
                <div className="nbfc-div">
                  <button
                    type="submit"
                    className="nbfc-btn"
                    onClick={handleAddData}
                    disabled={!loanDisbursed}
                  >
                    Submit
                  </button>
                </div>
              )}
              <div className="obligations-container">
                <table className="report-table1">
                  <thead style={{ backgroundColor: "rgb(207, 226, 243)" }}>
                    <tr>
                      <th style={{ border: "1px solid black" }}>
                        Bureau Vendor{" "}
                      </th>
                      <th style={{ border: "1px solid black" }}>Name</th>
                      <th style={{ border: "1px solid black" }}>Bureau Score</th>
                      <th style={{ border: "1px solid black" }}>
                        Loan start date
                      </th>
                      <th style={{ border: "1px solid black" }}>
                        DPD Loan in 3 months
                      </th>
                      <th style={{ border: "1px solid black" }}>
                        Loan with DPD &gt; 30
                      </th>
                      <th style={{ border: "1px solid black" }}>
                        loan with DPD &gt; 90
                      </th>
                      <th style={{ border: "1px solid black" }}>
                        Cheque/ECS bounce in 6 Months
                      </th>
                      <th style={{ border: "1px solid black" }}>
                        Cheque/ECS bounce in 12 Months
                      </th>
                    <th style={{ border: "1px solid black" }}>Tradelines</th>
                    {(deleteBureau || visible) && (
                      <th style={{ border: "1px solid black" }}>Action</th>
                    )}
                    </tr>
                  </thead>
                  <tbody>
                    {reqArray?.length > 0 &&
                      reqArray?.map((item, index) => {
                        // console.log(item);
                        return (
                          <tr key={item.bid}>
                            <td style={{ border: "1px solid black" }}>
                              {item.bureauVendor}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {item.customerName}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {item.cibilScore}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {item.loanStartDate}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {item.dpdLoan}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {item.dpdGreaterthen30}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {item.dpdGreaterthen90}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {item.cheque6Months}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {item.cheque12Months}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {item.tradelines}
                            </td>
                            {(deleteBureau || visible) && (
                              <td style={{ border: "1px solid black" }}>
                                {(deleteBureau || visible) && (
                                  <Tooltip title="Delete Bureau">
                                    <IconButton
                                      onClick={(e) => handleDeleteRow(item.bid, item.path)}
                                      disabled={!loanDisbursed}
                                    >
                                      <DeleteIcon
                                        sx={{
                                          color: loanDisbursed ? "red" : "gray",
                                        }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </>
          )}
      </form>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default Bureau;
